import { Alert, List } from '@mui/material';
import React from 'react';
import FreshwatchGroupsSearch from './FreshwatchGroupsSearch';
import { getPolyglot } from '../../../../../i18n';

export interface ListEntitiesSearchProps {
  readonly searchValue?: string;
  readonly close?: () => void;
}

function FreshwatchListEntitiesSearch(
  props: Readonly<ListEntitiesSearchProps>
) {
  const { searchValue } = props;
  const polyglot = getPolyglot();
  if (!searchValue?.length) {
    return (
      <Alert severity="info">
        {polyglot.t('device.search.message_type_to_search')}
      </Alert>
    );
  }
  return (
    <List>
      <FreshwatchGroupsSearch {...props} />
    </List>
  );
}

export default FreshwatchListEntitiesSearch;
